import React from 'react'
import axios from 'axios'

import Cidades from '../Cidades/Cidades.js'
import './rotasModule.css'
import {
    createEmptyRouteItem,
    ESTADOS,
    MOTIVOS,
    DIARIA_OPTIONS,
    TIPO_DIARIA_OPTIONS
} from './rotaHelpers'

export default class NovaRota extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                fiscal: localStorage.nome,
                estado: '',
                obsFiscal: '',
                qtdEstabelecimentos: 1,
                qtdAlternativas: 0,
                estabelecimentos: [createEmptyRouteItem()],
                alternativas: []
            },
            municipios: [],
            saving: false
        }
    }

    syncCount(type, nextCount) {
        this.setState((prevState) => {
            const currentItems = prevState.ficha[type]
            const updatedItems = [...currentItems]

            while (updatedItems.length < nextCount) {
                updatedItems.push(createEmptyRouteItem())
            }

            while (updatedItems.length > nextCount) {
                updatedItems.pop()
            }

            return {
                ficha: {
                    ...prevState.ficha,
                    [type]: updatedItems,
                    [type === 'estabelecimentos' ? 'qtdEstabelecimentos' : 'qtdAlternativas']: nextCount
                }
            }
        })
    }

    adjustCount(type, delta) {
        const key = type === 'estabelecimentos' ? 'qtdEstabelecimentos' : 'qtdAlternativas'
        const current = this.state.ficha[key]
        const minimum = type === 'estabelecimentos' ? 1 : 0
        const next = Math.max(minimum, current + delta)
        this.syncCount(type, next)
    }

    updateField = (event) => {
        const { name, value } = event.target

        this.setState((prevState) => ({
            ficha: {
                ...prevState.ficha,
                [name]: value
            }
        }))

        if (name === 'estado') {
            this.setState({ municipios: Cidades[value] || [] })
        }
    }

    updateRouteItem = (type, index, field, value) => {
        this.setState((prevState) => ({
            ficha: {
                ...prevState.ficha,
                [type]: prevState.ficha[type].map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value } : item)
            }
        }))
    }

    save = async (event) => {
        event.preventDefault()
        this.setState({ saving: true })

        try {
            const url = '/api/rota/rotas2'
            const { ficha } = this.state
            await axios.post(url, ficha)
            alert('Sua solicitação foi enviada, aguarde aprovação da coordenação.')
            window.location = '/MinhasRotas'
        } catch (error) {
            alert(error.response?.data || 'Erro ao salvar rota.')
        } finally {
            this.setState({ saving: false })
        }
    }

    renderItemCard(type, item, index, title, alternative = false) {
        return (
            <div className="col-12 mb-4" key={`${type}-${index}`}>
                <div className={`rota-item-card ${alternative ? 'alternative' : ''}`}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <p className="rota-eyebrow mb-1">{alternative ? 'Rota alternativa' : 'Rota principal'}</p>
                            <h4 className="rota-section-title mb-0">{title} #{index + 1}</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 mb-3">
                            <label className="rota-label">Estabelecimento</label>
                            <input className="form-control rota-input" value={item.estabelecimento} onChange={(e) => this.updateRouteItem(type, index, 'estabelecimento', e.target.value)} />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Data</label>
                            <input type="date" className="form-control rota-input" value={item.data} onChange={(e) => this.updateRouteItem(type, index, 'data', e.target.value)} />
                        </div>
                        <div className="col-md-8 mb-3">
                            <label className="rota-label">Endereço</label>
                            <input className="form-control rota-input" value={item.endereco} onChange={(e) => this.updateRouteItem(type, index, 'endereco', e.target.value)} />
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Município</label>
                            <select className="custom-select rota-input" value={item.municipio} onChange={(e) => this.updateRouteItem(type, index, 'municipio', e.target.value)}>
                                <option value=""></option>
                                {this.state.municipios.map((municipio) => <option key={municipio.nome} value={municipio.nome}>{municipio.nome}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Motivo</label>
                            <select className="custom-select rota-input" value={item.motivo} onChange={(e) => this.updateRouteItem(type, index, 'motivo', e.target.value)}>
                                <option value=""></option>
                                {MOTIVOS.map((motivo) => <option key={motivo} value={motivo}>{motivo}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Diária</label>
                            <select className="custom-select rota-input" value={item.diaria} onChange={(e) => this.updateRouteItem(type, index, 'diaria', e.target.value)}>
                                <option value=""></option>
                                {DIARIA_OPTIONS.map((option) => <option key={option} value={option}>{option}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Tipo de diária</label>
                            <select className="custom-select rota-input" value={item.tipoDiaria} onChange={(e) => this.updateRouteItem(type, index, 'tipoDiaria', e.target.value)}>
                                <option value=""></option>
                                {TIPO_DIARIA_OPTIONS.map((option) => <option key={option} value={option}>{option}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { ficha, saving } = this.state

        return (
            <div className="container rota-page">
                <div className="rota-hero">
                    <p className="rota-eyebrow mb-2">Módulo de Rotas</p>
                    <h1 className="rota-title mb-2">Nova rota</h1>
                    <p className="rota-subtitle mb-0">Cadastre rotas principais e alternativas em um formato estruturado, com preenchimento mais limpo e consistente.</p>
                </div>

                <div className="rota-surface mb-4">
                    <div className="row align-items-end">
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Estado</label>
                            <select className="custom-select rota-input" name="estado" value={ficha.estado} onChange={this.updateField}>
                                <option value=""></option>
                                {ESTADOS.map((estado) => <option key={estado.value} value={estado.value}>{estado.label}</option>)}
                            </select>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Rotas principais</label>
                            <div className="rota-counter">
                                <button type="button" className="btn btn-light" onClick={() => this.adjustCount('estabelecimentos', -1)}>-</button>
                                <span>{ficha.qtdEstabelecimentos}</span>
                                <button type="button" className="btn btn-light" onClick={() => this.adjustCount('estabelecimentos', 1)}>+</button>
                            </div>
                        </div>
                        <div className="col-md-4 mb-3">
                            <label className="rota-label">Rotas alternativas</label>
                            <div className="rota-counter">
                                <button type="button" className="btn btn-light" onClick={() => this.adjustCount('alternativas', -1)}>-</button>
                                <span>{ficha.qtdAlternativas}</span>
                                <button type="button" className="btn btn-light" onClick={() => this.adjustCount('alternativas', 1)}>+</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rota-surface mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <p className="rota-eyebrow mb-1">Execução principal</p>
                            <h2 className="rota-section-title mb-0">Rotas principais</h2>
                        </div>
                    </div>
                    <div className="row">
                        {ficha.estabelecimentos.map((item, index) => this.renderItemCard('estabelecimentos', item, index, 'Rota principal'))}
                    </div>
                </div>

                <div className="rota-surface mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <p className="rota-eyebrow mb-1">Plano alternativo</p>
                            <h2 className="rota-section-title mb-0">Rotas alternativas</h2>
                        </div>
                    </div>
                    <div className="row">
                        {ficha.alternativas.length === 0 && <div className="col-12"><p className="rota-muted mb-0">Nenhuma alternativa adicionada.</p></div>}
                        {ficha.alternativas.map((item, index) => this.renderItemCard('alternativas', item, index, 'Rota alternativa', true))}
                    </div>
                </div>

                <div className="rota-surface mb-4">
                    <label className="rota-label">Observações</label>
                    <textarea rows="4" className="form-control rota-input" name="obsFiscal" value={ficha.obsFiscal} onChange={this.updateField} />
                </div>

                <div className="d-flex justify-content-end">
                    <button className="btn rota-primary-button" onClick={this.save} disabled={saving}>
                        {saving ? 'Salvando...' : 'Salvar rota'}
                    </button>
                </div>
            </div>
        )
    }
}
